<template>
  <div>
    <h2 class="bb-page-title">Users List</h2>
    <div class="bb-users">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"/>
      </transition>
      <transition name="fade" mode="out-in">
        <ModalWindow @close="closeModal" v-if="openFormNewUser || editUserOpen">
          <new-user-form v-if="openFormNewUser" @close="closeModal"/>
          <new-user-form v-if="editUserOpen" :user="editUser" :index="editUserIndex" :edit="true" @close="closeModal"/>
        </ModalWindow>
      </transition>
      <transition name="fade" mode="out-in">
        <ModalWindow
          v-if="isShowTerminationModal"
          customWrapperClass="bb-modal-wrapper_min-padding"
          :isCloseBig="true"
          :isFooter="true"
          :isBigRightButton="true"
          buttonRightName="TERMINATE"
          @close="isShowTerminationModal = false"
          @handlerClick="handlerClick"
        >
          <EmploymentTerminationModal
            :item.sync="currentItem"
          />
        </ModalWindow>
      </transition>
      <SettingsUsersPanel
        :tabId.sync="tabId"
        @inputSearch="inputSearch"
        @createUser="createUser"
      />
      <div class="bb-users-table-wrapper" ref="bbUserTable">
        <table class="bb-users-table bb-table">
          <thead class="bb-table-header">
          <tr class="bb-table-header-row">
            <th class="bb-table-header__item bb-table-header__item_hide"/>
            <th
              v-if="isActiveTab"
              class="bb-table-header__item bb-table-header__item_hr"
            >
              HR DIRECTORY
            </th>
            <th class="bb-table-header__item">NAME</th>
            <th class="bb-table-header__item">POSITION</th>
            <th class="bb-table-header__item">ROLE</th>
            <th class="bb-table-header__item">EMAIL</th>
            <th class="bb-table-header__item bb-table-header__item_toolbar"/>
            <th class="bb-table-header__item bb-table-header__item_hide"/>
          </tr>
          </thead>
          <tbody class="bb-table-body">
          <tr class="bb-table-body-row bb-table-body-row_users"
              v-for="(user, index) in users"
              :key="user.id"
              @mouseenter="setActiveRow(index)"
              @mouseleave="activeItemIndex = false, deleteConfirmIndex = false"
              :class="{'bb-table-body-row_active':activeItemIndex === index}">
            <td>
              <div class="bb-table-body-row__after" :ref="'bbRowAfter' + index"/>
            </td>
            <td
              v-if="isActiveTab"
              class="bb-table-body__item"
            >
              <div
                class="bb-table-body__item_hr"
                :class="{'bb-table-body__item_blue': user.isHrIncluded}"
                @click="addHrUser(user, index)"
                v-html="HrUserIcon()"
              />
            </td>
            <td class="bb-table-body__item bb-table-body__item_user">
              <div
                class="bb-table-body-first-name"
                @click="goToCard(user)"
              >
                <div class="bb-table-body__item_avatar">
                  <img :src="user.image ? user.image.path : avatarUserDefault"/>
                </div>
                {{ user.username }}
              </div>
            </td>
            <td class="bb-table-body__item">
              {{ user.position ? user.position.name : 'n/a' }}
            </td>
            <td class="bb-table-body__item">{{ getNameRole(user) }}</td>
            <td class="bb-table-body__item">{{ user.email || '' }}</td>
            <td class="bb-table-body__item">
              <Toolbar v-if="activeItemIndex === index"
                       :delete-index="deleteConfirmIndex"
                       :index="index"
                       :item="user"
                       :no-delete="userInfo.id === user.id || isActiveTab"
                       :noEdit="!isActiveTab"
                       :isNoUser="isActiveTab"
                       @deleteOpen="deleteConfirmIndex = index"
                       @deleteClose=" deleteConfirmIndex = false"
                       @openEdit="editUserFrom"
                       @deleteItem="openDoubleDelete"
                       @onClickIcon="onClickIcon"
              />
              <DoubleDelete v-if="showModalDelete.id === user.id"
                            :id="user.id"
                            :password="passwordUsersDelete"
                            :title="(user.username).toUpperCase()"
                            @close="showModalDelete = {}"
                            @delete="initDeleteUser"/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Pagination :data="fullInfoUsers" :getQuery="getUserList" :limit="defLimit" class="bb-pagination"/>
  </div>
</template>

<script>
import avatarUserDefault from '@/assets/images/avatar-user-default.png'
import NewUserForm from '../Forms/NewUserForm'
import UsersListApi from '@/api/UsersList/api'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import Pagination from '@/components/Main/Pagination/Pagination'
import {FOUNDER, CEO, ROLES_LIST} from '@/constants/roles'
import Table from '@/components/Main/Table/Table'
import {usersListTable, usersListTableTableColumns} from '@/constants/TablesOptions/usersListTable'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import _ from 'lodash'
import DoubleDelete from '@/components/Main/DoubleDelete/DoubleDelete'
import {passwordUsersDelete} from '@/constants/passwordForDelete'
import getGmailTokens from '@/mixin/getGmailTokens'
import {HrUserIcon} from '../../../constants/icon'
import SettingsUsersPanel from './SettingsUsersPanel/SettingsUsersPanel'
import {USER_ACTIVE_TAB_ID} from '@/constants/Tabs/usersListTabs'
import EmploymentTerminationModal from './EmploymentTerminationModal/EmploymentTerminationModal'

export default {
  name: 'SettingsUsers',
  components: {
    EmploymentTerminationModal,
    SettingsUsersPanel,
    ModalWindow,
    NewUserForm,
    Toolbar,
    Table,
    Pagination,
    LoaderFly,
    DoubleDelete
  },
  mixins: [getGmailTokens],
  data () {
    return {
      loaderRun: false,
      fullInfoUsers: '',
      defLimit: 30,
      optionsTable: usersListTable,
      avatarUserDefault: avatarUserDefault,
      activeItemIndex: false,
      openFormNewUser: false,
      deleteConfirmOpen: false,
      deleteConfirmIndex: false,
      editUserOpen: false,
      editUser: false,
      editUserIndex: false,
      searchWords: '',
      passwordUsersDelete: passwordUsersDelete,
      showModalDelete: {
        index: false,
        id: false
      },
      isShowTerminationModal: false,
      currentItem: {},
      tabId: 1,
      deleteStatus: ['deleteStatus[]=1'],
      HrUserIcon
    }
  },
  computed: {
    isActiveTab () {
      return this.tabId === USER_ACTIVE_TAB_ID
    },
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    },
    usersListColumnsData: {
      get: function () {
        return this.$store.getters.usersListColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setUsersListColumnsData', data)
      }
    },
    userInfo: {
      get: function () {
        return this.$store.getters.userInfo
      },
      set: function (data) {
        this.$store.dispatch('setUserInfo', data)
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    },
    getWithSearch: function () {
      return _.debounce(this.getUserList, 250)
    }
  },
  methods: {
    handlerClick () {
      const { deleteStatus, deleteDate, id, image, access } = this.currentItem
      const updateUser = {
        deleteStatus,
        deleteDate,
        id,
        access,
        image: image ? image.id : null
      }
      this.updateUser(updateUser)
      this.isShowTerminationModal = false
      const currentIndex = this.users.findIndex(el => el.id === id)
      if (currentIndex === -1) return
      this.users.splice(currentIndex, 1)
    },
    async updateUser (updateUser, index) {
      try {
        await UsersListApi.editUser(updateUser)
      } catch (e) {
        this.users[index].isHrIncluded = !this.users[index].isHrIncluded
        console.error(e)
      }
    },
    goToCard ({id, isHrIncluded}) {
      if (isHrIncluded) {
        this.$router.replace({
          name: 'EmployeesCard',
          params: { id, tab: 'salary', nameRouteChildren: 'salary' }
        })
          .catch(err => err)
      } else {
        this.$router.push({name: 'UserCard', params: {id}}).catch(err => err)
      }
    },
    addHrUser (user, index) {
      this.users[index].isHrIncluded = !this.users[index].isHrIncluded
      this.updateUser(this.users[index], index)
    },
    inputSearch (e) {
      const val = e.target.value
      const searchValue = val.toLowerCase().trim()
      this.getWithSearch({page: 1, limit: this.defLimit, search: searchValue})
    },
    setActiveRow (index) {
      this.activeItemIndex = index
      this.deleteConfirmOpen = false
      const widthTable = _.get(this.$refs, 'bbUserTable.offsetWidth', false)
      const afterElement = _.get(this.$refs, `bbRowAfter${index}`, [])
      if (widthTable && afterElement[0]) {
        afterElement[0].style.width = widthTable - 4 + 'px'
      }
    },
    getNameRole (user) {
      const valueRole = user.role
      const role = ROLES_LIST.find(item => item.id === valueRole)
      try {
        return role.name
      } catch (e) {
        console.error(e)
      }
    },
    createUser () {
      this.openFormNewUser = true
      this.userInfo.email = ''
    },
    closeModal () {
      this.editUserOpen = false
      this.openFormNewUser = false
    },
    editUserFrom (index) {
      this.editUser = this.users[index]
      this.editUserIndex = index
      this.editUserOpen = true
    },
    openDoubleDelete (index, id) {
      this.showModalDelete = {index, id}
    },
    onClickIcon (item) {
      this.isShowTerminationModal = true
      this.currentItem = item
    },
    initDeleteUser (id) {
      const index = _.get(this.showModalDelete, 'index', false)
      this.deleteUser(index, id)
    },
    deleteUser (index, id) {
      this.users.splice(index, 1)
      UsersListApi.deleteUser(id)
        .then((resp) => {
          this.deleteConfirmOpen = false
          this.deleteConfirmIndex = false
          this.showModalDelete = {}
        })
        .catch((err) => {
          console.error(err)
          this.showModalDelete = {}
        })
    },
    getUserList ({limit, page, search}) {
      search ? this.searchWords = `&search=${search}` : this.searchWords = ''
      this.loaderRun = true
      UsersListApi.getUsersList({limit, page, filter: this.searchWords, deleteStatus: this.deleteStatus})
        .then((resp) => {
          this.loaderRun = false
          this.fullInfoUsers = resp.data
          this.users = _.filter(resp.data.users, item => item)
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.usersListColumnsData = usersListTableTableColumns
    const checkRole = this.userInfo.role === FOUNDER.id || this.userInfo.role === CEO.id
    if (checkRole) {
      this.getUserList({limit: this.defLimit})
    }
  },
  watch: {
    activeCompany: function () {
      if (this.userInfo.role === FOUNDER.id || this.userInfo.role === CEO.id) {
        this.getUserList({limit: this.defLimit})
      }
    },
    tabId () {
      this.fullInfoUsers = {}
      this.users = []
      this.deleteStatus = this.isActiveTab ? ['deleteStatus[]=1'] : ['deleteStatus[]=2', 'deleteStatus[]=3']
      this.getUserList({limit: this.defLimit, page: 1})
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bb-users {
  @include global-font;
  margin-top: 38px;

  &-table-wrapper {
    height: calc(100vh - 273px);
    overflow-y: scroll;
    position: relative;
    background: $color-white;
    box-shadow: 0 0 20px rgba($color-black, 0.05);
    border-radius: 5px;
  }
}

.bb-table-body {

  &-first-name {
    align-items: center;
    text-transform: capitalize;
  }

  &__item_avatar {
    margin: 0 16px 0 0;
  }
}

  .bb-table-header {
    position: sticky;
    top: 0;
    background: $color-white;
    z-index: 100;

    &:after {
      content: '';
      position: absolute;
      left: 22px;
      right: 22px;
      height: 1px;
      bottom: 0;
      background-color: #F4F4F4;
    }
  }

  .bb-users-table-wrapper {

    &::-webkit-scrollbar {
      width: 4px;
      height: 0;
      background-color: $color-white;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-denim;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/SettingsUsers/Users.vue